import { QueryDtoOf } from '@40seas/entities/common';
import { Attachment } from './attachment.entity';

export class QueryAttachmentDto extends QueryDtoOf(Attachment) {}
